// A stray % in the city would make decodeURIComponent throw and take the row down with it.
const decode = (text: string) => {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
};

const getRegion = (city: string | null | undefined, region: string | null | undefined) => {
  const decodedCity = city && decode(city);
  return decodedCity && region ? `${decodedCity}, ${region}` : decodedCity || region;
};

export default getRegion;
